import { Video, Clock } from 'lucide-react';
import type { LiveStatusDoc, CaseRecord } from '../types';

const SAMPLE_CASE: CaseRecord = {
  caseNumber: 'WP/12345/2026',
  location: 'madras',
  date: '20260627',
  court: '7',
  courtRemarks: '',
  caseRemarks: 'Listed as per directions of the Hon\'ble Court dated 03.06.2026',
  judgeName: ['S. Vaidyanathan'],
  itemNumber: 23,
  hearingType: 'FOR ADMISSION',
  petitioner: 'R. SUNDARAJAN AND ANOTHER',
  respondents: [
    'THE STATE OF TAMIL NADU rep. by its Secretary, Home Department, Secretariat, Chennai-9',
    'THE DIRECTOR GENERAL OF POLICE, Chennai-4',
    'THE SUPERINTENDENT OF POLICE, Coimbatore District',
  ],
  petitionerAdvocate: 'MR. A. KUMAR, MR. P. RAGHUNATHAN, MR. S. KRISHNAMOORTHY',
  respondentAdvocate: 'MR. B. RAJAN, ADDITIONAL ADVOCATE GENERAL assisted by MR. V. SENTHILKUMAR, GOVERNMENT PLEADER',
  advocates: [],
  connectedMatters: [
    { caseNumber: 'WP/12346/2026', petitioner: 'S. KRISHNAN', respondent: '', petitionerAdvocate: '', respondentAdvocate: '' },
    { caseNumber: 'WMP/15001/2026', petitioner: 'R. SUNDARAJAN AND ANOTHER', respondent: '', petitionerAdvocate: '', respondentAdvocate: '' },
  ],
  sourceXml: '',
  lastUpdated: Date.now(),
};

export const SAMPLE_COURT_DOC: LiveStatusDoc = {
  id: 'sample_madras_7',
  location: 'madras',
  court: '7',
  judgeName: ['S. Vaidyanathan'],
  judgeHeading: 'S. Vaidyanathan',
  judgeImageUrls: [],
  currentItemNumber: 23,
  currentCaseNumber: 'WP/12345/2026',
  currentCaseDetail: SAMPLE_CASE,
  previousItemNumber: 22,
  previousCaseNumber: 'WA/6789/2025',
  status: 'live',
  polledAt: Date.now(),
  lastCaseAt: Date.now() - 4 * 60 * 1000,
  itemsCalledToday: Array.from({ length: 23 }, (_, i) => i + 1),
  totalCasesToday: 60,
  vcLink: 'https://teams.microsoft.com/l/meetup-join/sample',
};

export const SAMPLE_ORDERS = [
  { date: '24 Jun 2026', pdfUrl: 'https://mhc.tn.gov.in' },
  { date: '17 Jun 2026', pdfUrl: 'https://mhc.tn.gov.in' },
  { date: '03 Jun 2026', pdfUrl: 'https://mhc.tn.gov.in' },
];

interface Props {
  onClick: () => void;
}

export function SampleCourtCard({ onClick }: Props) {
  return (
    <div className="court-card court-card--live court-card--sample" onClick={onClick} role="button" tabIndex={0}>
      <div className="court-card__sample-strip">SAMPLE — tap to preview details</div>

      {/* Header */}
      <div className="court-card__header">
        <div className="court-card__meta">
          <div className="court-card__title-row">
            <span className="court-card__number">Court 7</span>
            <div className="court-card__badges">
              <span className="court-card__vc-badge">
                <Video size={11} strokeWidth={2.5} /><span>VC</span>
              </span>
              <span className="live-tag live-tag--blinking">LIVE</span>
            </div>
          </div>
          <span className="court-card__judge">S. Vaidyanathan</span>
        </div>
      </div>

      {/* Body */}
      <div className="court-card__body">
        <div className="court-card__hero-row">
          <div className="court-card__item-block">
            <span className="court-card__item-label">ITEM</span>
            <span className="court-card__item-number-large">23</span>
          </div>
          <div className="court-card__tags-col">
            <span className="court-card__elapsed"><Clock size={13} />4 min ago</span>
            <span className="court-card__hearing-tag court-card__hearing-tag--green">ADMISSION</span>
          </div>
        </div>

        <div className="court-card__progress-container">
          <div className="court-card__progress-track">
            <div className="court-card__progress-bar" style={{ width: '38%' }} />
          </div>
          <div className="court-card__progress-text">23 of 60 cases called</div>
        </div>

        <div className="court-card__case-number">WP/12345/2026</div>

        <div className="court-card__parties">
          <span className="court-card__petitioner">R. SUNDARAJAN AND ANOTHER</span>
          <span className="court-card__vs"> v. </span>
          <span className="court-card__respondent">THE STATE OF TAMIL NADU</span>
        </div>

        <div className="court-card__previous-case">
          <span className="court-card__previous-label">Previously:</span>
          {' '}Item 22 &bull; WA/6789/2025
        </div>
      </div>
    </div>
  );
}
